import React, { useEffect } from 'react';
import { useAuth } from '../hooks';
import { useNavigate } from 'react-router-dom';

const LogoutScreen: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Perform logout if user is authenticated
    if (isAuthenticated) {
      logout();
    } else {
      // If user is already logged out, redirect to login
      navigate('/login');
    }
  }, [isAuthenticated, logout, navigate]);
  
  return (
    <div className="logout-container">
      <div className="logout-message">
        <h2>Logging Out</h2>
        <p>You are being logged out of the application. Please wait...</p>
      </div>
    </div>
  );
};

export default LogoutScreen;